import { UseDisclosureReturn } from "@chakra-ui/react";
import { useMemo } from "react";

import { useSearchState } from "./use-search-state";

type UseSearchDisclosureOptions = {
  searchParams: URLSearchParams;
  setSearchParams: (params: URLSearchParams) => void;
};

/*
Chakra docs: useDisclosure is a custom hook used to help handle common open, close, or toggle scenarios. It can be used to control feedback component such as Modal, AlertDialog, Drawer, etc.

This is a version that stores the open or closed state in the URL search params.
*/
export const useSearchDisclosure = (
  key: string,
  options: UseSearchDisclosureOptions
): UseDisclosureReturn => {
  const [isOpen, setIsOpen] = useSearchState(key, false, {
    ...options,
    dontEverSaveInHistory: true,
  });

  const onOpen = useMemo(() => () => setIsOpen(true), [setIsOpen]);
  const onClose = useMemo(() => () => setIsOpen(false), [setIsOpen]);
  const onToggle = useMemo(() => () => setIsOpen((prev) => !prev), [setIsOpen]);

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
    isControlled: true,
    getButtonProps: (props) => props ?? {},
    getDisclosureProps: (props) => props ?? {},
  };
};
